import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AppTable from './ApplicationeTable/AppsTable';
import PinGate from "./PinGate";   // <-- import PIN lock

const App = () => {

  return (
     <PinGate> 
      <Router>
        <Routes>
          <Route path="/" element={<AppTable />} />
        </Routes>
      </Router>
    </PinGate>
  );
};

export default App;